module.exports = __webpack_public_path__ + "img/farewell_3.8dda48a4.jpg";